import { useLocation } from 'react-router-dom';

const useURLSearchParams = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export default useURLSearchParams;
